import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class HomeDivConfigApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'home-div-config'
  }

}